/**
 * 列表
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2022/9/13      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */

import React from 'react'
import PropTypes from "prop-types";
import {Button,Table,message,Modal,Pagination,Empty,Spin} from 'antd';
import {symbolMoneyUtil} from '@utils/utils';
import { loadImage } from "@utils/image-func";
import Lang from "@components/Lang/Lang";
import LazyLoad from 'react-lazy-load';
import dayjs from "dayjs";
import "./index.less";
const Locale = require("../../../../../../utils/locale").default;
const locale = Locale.current();
const config = require("@config/config");

class Cart extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            loading:true,
            visible:false,
            list:[],
            model:{},
            selectedRowKeys:[],
            pagingQuery:{
                pageSize:200,
                pageIndex:1,
                total:0
            },
        }
    }

    /**
     * 获取数据
     */
    getData(pageIndex){
        this.setState({
            loading:true,
        },()=>{
            var postData = {
                fuzzySampId:this.props.id,
                pagingQuery:{
                    pageIndex: pageIndex||this.state.pagingQuery.pageIndex,
                    pageSize: this.state.pagingQuery.pageSize
                }
            }
            $.ajax({
                url: "/service/mg/fuzzy/me-recommend-goods/list",
                type:'post',
                dataType: "json",
                contentType: 'application/json',
                data:JSON.stringify(postData),
                success:(res)=>{
                    var obj = {
                        loading:false,
                        selectedRowKeys:[],
                    };
                    if(res.success&&res.valid){
                        (res.models||[]).map((item)=>{
                            let array = item.customerSampleFileUrl?item.customerSampleFileUrl.split("."):[];
                            if(array.length>0){
                                let extend = array[array.length-1]||[]
                                item.customerSampleFileExtend = extend;
                            }
                        })
                        obj.list = res.models||[];
                        obj.model = res.model||{};
                    }

                    if(res.paging){
                        obj.pagingQuery = {
                            pageIndex:res.paging&&res.paging.pageNum,
                            pageSize:res.paging&&res.paging.pageSize,
                            total:res.paging&&res.paging.total
                        }
                    }else{
                        obj.pagingQuery = {
                            pageSize:this.state.pagingQuery.pageSize,
                            total:0
                        }
                    }
                    this.setState(obj);
                },
                error:()=>{
                    this.setState({
                        loading:false
                    });
                }
            });
        })
    }

    /**
     * 获取表格交互
     **/
    getColumns(props){
        const { remove,openImg,currencySymbol } = props;
        const address = config.essaone[locale];
        return [
            {
                title: <div>
                    <span className="color089">{__getServerLanguage("ShangPinXinXi")}</span>
                </div>,
                render(text,item,index) {
                    let obj = item.customerSampleFileId?{
                        defaultList:[{
                                fileId:item.customerSampleFileId,
                                url:item.customerSampleFileUrl,
                                extend:item.customerSampleFileExtend
                            }]
                    }:{
                        defaultList:[]
                    };
                    return <div className="flex-box">
                        <div>
                            {
                                item.goodsSkuVO.skuPicUrl?
                                    <LazyLoad height={100}
                                              offset={0}>
                                        <img className="img100 cursor-p" src={loadImage(item.goodsSkuVO.skuPicUrl,100)}
                                             onClick={openImg.bind(this,item.goodsSkuVO.skuPicUrl)} alt=""/>
                                    </LazyLoad>
                                    :
                                    <img className="img100" src="http://oss.essa.cn/04d1ca90-811f-4d61-96d4-ada86e4bfedb.svg" alt=""/>
                            }

                        </div>
                        <div className="ml_12">
                            <div className="base-info">
                                <a className="ellipsis-name" title={item.goodsSkuVO.name||'-'} onClick={()=>{
                                    window.open(`${address}/${item.goodsSkuVO.goodsId}.html?skuNo=${item.goodsSkuVO.no}`);
                                }}>{item.goodsSkuVO.name||'-'}</a>
                                <span>{item.goodsSkuVO.no||'-'}</span>
                                <span>{item.supplierVO.receiveAreaName||'-'}</span>
                            </div>
                            <div className="color066 font_12">{item.goodsSkuVO.categoryPathName}</div>
                            <div className="color066 font_12 mt_6">
                                <span>{item.supplierVO.createTime?dayjs(item.supplierVO.createTime).format('YYYY-MM-DD HH:mm:ss'):''}</span>
                                <span className="ml_16">{item.supplierVO.name} {item.supplierVO.code}</span>
                            </div>
                            <div className="mt_6">
                                <b className="color089">
                                    {__getServerLanguage('DDPJiaGe')} <b>{symbolMoneyUtil(item.goodsSkuVO.salePrice,currencySymbol)}</b>
                                </b>
                                <span className="ml_16 color066">
                                    {__getServerLanguage('HuoQi')} <span>{item.goodsSkuVO.deliverDay||'-'}</span>
                                </span>
                                <span className="ml_16 color066">
                                    {__getServerLanguage('MOQ')} <span>{item.goodsSkuVO.purchaseMoq||'-'}</span>
                                </span>
                            </div>
                        </div>
                    </div>
                },
            },
            {
                title: <div className="color089">{__getServerLanguage("CaoZuo")}</div>,
                width: 220,
                render: (text,item) => {
                    return (
                        <div className="option-wrap">
                            {
                                item.isRecommendToBuyer?
                                    <span className="is-recommend-to-buyer">{__getServerLanguage('YiTuiJian')}</span>
                                    :
                                    <Button className="mt_5" onClick={(e)=>{
                                        remove(e,item)
                                    }}>{__getServerLanguage('YiChuXuanPin')}</Button>
                            }
                        </div>
                    )
                },
            },
        ]
    }

    /**
     * 移除推荐
     * @param e
     * @param item
     * @return {boolean}
     */
    remove(e,item){
        var postData = {}
        if(item){
            postData.ids=[item.id]
        }else{
            var ids = [];
            (this.state.list||[]).forEach((model)=>{
                if(!model.isRecommendToBuyer&&this.state.selectedRowKeys.indexOf(model.id)!=-1){
                    ids.push(model.id)
                }
            })
            if(ids.length==0){
                postData.fuzzySampId = this.props.id;
            }else{
                postData.ids = ids;
            }
        }

        $.ajax({
            url: "/service/mg/fuzzy/me-recommend-goods/delete",
            type:'post',
            dataType: "json",
            contentType: 'application/json',
            data:JSON.stringify(postData),
            success:(res)=>{
                if(res.success&&res.valid){
                    message.success(__getServerLanguage('YiChuChengGong'));
                    this.getData(1);
                    this.props.removeCallBack();
                }
            }
        });
    }

    /**
     * 切换展示
     * @param visible
     */
    changeVisible(visible){
        this.setState({
            list:[],
            visible:visible
        },()=>{
            if(visible){
                this.getData();
            }
        })
    }

    /**
     * 推荐
     * @param callback
     * @private
     */
    _recommendToBuyer(callback){
        $.ajax({
            url: "/service/mg/fuzzy/me-recommend-goods/to-buyer",
            type:'post',
            dataType: "json",
            contentType: 'application/json',
            data:JSON.stringify({
                id:this.props.id
            }),
            success:(res)=>{
                if(res.success&&res.valid){
                    callback();
                }
            }
        });
    }

    /**
     * 提交
     */
    submit(){
        let _this = this;
        let needTip = (Number(this.state.model.maxFeedbackSkuNum)<Number(this.state.pagingQuery.total||0))?true:false;
        if(this.state.model.surplusFeedbackSkuNum<=0){
            // message.info(`推荐当前最多回复${this.state.model.maxFeedbackSkuNum}款`);
            message.info(__getServerLanguage('TuiJianDangQianZuiDuoHuiFuNKuan',this.state.model.maxFeedbackSkuNum));
            return false;
        }else if(needTip){
            Modal.confirm({
                title:__getServerLanguage('TiShi'),
                width:420,
                icon:false,
                // content: `已选品 ${this.state.pagingQuery.total||0} 款，任务只允许推荐 ${this.state.model.maxFeedbackSkuNum} 款，超出的选品将被忽略。是否继续推荐？`
                content: __getServerLanguage('YiXuanPinNKuanRenWuZhiYunXuTuiJianNKuan',this.state.pagingQuery.total||0,this.state.model.maxFeedbackSkuNum),
                onOk:()=>{
                    _this._recommendToBuyer(()=>{
                        this.changeVisible(false);
                        message.success(__getServerLanguage('TuiJianChengGong'));
                    });
                }
            })
        }else{
            this._recommendToBuyer( ()=> {
                this.changeVisible(false);
                message.success(__getServerLanguage('TuiJianChengGong'));
            })
        }

    }

    /**
     * 切换分页
     * @param page 当前页面
     * @param pageSize 分页大小
     */
    onChangePage = (page, pageSize) => {
        this.setState({
            pagingQuery: {
                pageSize: pageSize,
                pageIndex: page
            }
        }, () => {
            this.getData()
        })
    }

    /**
     * 放大图片
     */
    openImg(url){
        Modal.info({
            width: 500,
            title:false,
            icon:<i></i>,
            //这个方法无法控制按钮，故通过样式的方式屏蔽下方按钮。
            className:"modal-big-wrap",
            closable:true,
            content:<img src={loadImage(url,500)} style={{width:'100%'}} alt=""/>
        });
    }

    /**
     * 全选
     * @param type true全选，false 取消全选
     **/
    selectAll(type){
        var selectedRowKeys = [];
        if(type){
            (this.state.list||[]).forEach((model)=>{
                selectedRowKeys.push(model.id)
            })
        }
        this.setState({
            selectedRowKeys:selectedRowKeys
        })
    }

    getRowSelection(){
        return {
            selectedRowKeys:this.state.selectedRowKeys,
            onChange: (selectedRowKeys, selectedRows) => {
                this.setState({
                    selectedRowKeys:selectedRowKeys
                })
            }
        }
    }

    render(){
        let columns = this.getColumns;
        let list = this.state.list||[];
        let rowSelection = this.getRowSelection();
        let {currencySymbol = ''} = this.props;
        return (
            <div>
                <Modal maskClosable={false}
                        bodyStyle={{padding:0}}
                        open={this.state.visible}
                        closable={false}
                        title={<div className="title">
                            {__getServerLanguage('YiXuanShangPin')}
                            {this.state.pagingQuery.total||0}
                            （
                                {__getServerLanguage('WeiTuiJianNKuan',
                                    this.state.model.notRecommendToBuyerSkuNum!==0?
                                        (this.state.model.notRecommendToBuyerSkuNum||'-'):0)
                                }
                            ）
                        </div>}
                        footer={[
                            <Button onClick={this.changeVisible.bind(this,false)}>{__getServerLanguage('GuanBi')}</Button>,
                            <Button type="primary"
                                    disabled={this.state.list.length==0}
                                    onClick={this.submit.bind(this)}>{__getServerLanguage('TuiJianShangPin')}</Button>
                        ]}
                        onClose={this.changeVisible.bind(this,false)}
                       width={900}>
                    <div className="fuzzy-recommend-cart__wrap">
                        <div className="fuzzy-recommend-cart__header">
                            <div>

                                <span className="tip">{__getServerLanguage('ChongFuDeShangPinHuiFuKeHuShiXiTongHuiZiDongQuZhong')}</span>
                            </div>
                            <div>
                                <a className={`clear-btn${this.state.list.length==0?' disabled':''}`}
                                   onClick={this.state.list.length!=0&&this.remove.bind(this)}>{__getServerLanguage('QingKongXuanPin')}</a>
                            </div>
                        </div>

                        <Spin spinning={this.state.loading}>
                            {
                                this.state.list.length==0?
                                    <Empty description={Lang({id: "ZanWuShuJu", default: "暂无数据"})}></Empty>
                                    :
                                    <div className="item">
                                        <Table
                                            bordered={true}
                                            className="list-wrap"
                                            scroll={{ y: 440 }}
                                            // rowSelection={rowSelection}
                                            rowKey="id"
                                            columns={columns({
                                                currencySymbol:currencySymbol,
                                                openImg:this.openImg.bind(this),
                                                remove: this.remove.bind(this),
                                            })}
                                            dataSource={list}
                                            pagination={false}
                                        ></Table>
                                    </div>
                            }
                        </Spin>

                        {/*分页*/}
                        {
                            this.state.pagingQuery.total>0?
                                <div className="mt_10 mt_10 pagination-wrap">
                                    <Pagination
                                        showSizeChanger={false}
                                        current={this.state.pagingQuery.pageIndex || 1}
                                        pageSize={this.state.pagingQuery.pageSize}
                                        total={this.state.pagingQuery.total || 0}
                                        onChange={this.onChangePage.bind(this)}/>
                                </div>
                                :
                                ''
                        }
                    </div>

                    {/*操作栏*/}
                    {/*<div className="fuzzy-recommend-cart__footer">
                        <div className="flex-box ant-row-flex-space-between align-self-center">
                            <Button onClick={this.selectAll.bind(this,(this.state.list.length!=this.state.selectedRowKeys.length))}
                                disabled={this.state.list.length==0}>{
                                (this.state.list.length!=this.state.selectedRowKeys.length)?
                                    __getServerLanguage('QuanXuanBenYe'):
                                    __getServerLanguage('QuXiaoQuanXuan')
                            }</Button>
                            <Button className="margin-left-8" disabled={this.state.list.length==0} onClick={this.state.list.length!=0&&this.remove.bind(this)}>批量移除</Button>
                        </div>
                        <Button type="primary" disabled={this.state.list.length==0} onClick={this.submit.bind(this)} size="large">提交补充</Button>
                    </div>*/}
                </Modal>
                <span className="fixed-select-item" onClick={this.changeVisible.bind(this,true)}>
                    <i className="ri-shopping-basket-fill"></i>
                    <span className="num">{this.props.count || 0}</span>
                </span>

            </div>
        )
    }
}

Cart.defaultProps = {
    count:0,
    id:null,
    currencySymbol:''
}

Cart.propTypes = {

}

export default Cart;
